// Props for a photo on the public site: its own className/style plus the admin framing
// (src/utils/framing.js). With no framing it returns exactly { className, style } so the
// markup is unchanged.
//
//   <img {...framed(c.hero.imageFraming, "abt-hero__img")} src=… />
//
// Besides the focus point / zoom variables it sets --fi-d/t/p: the clip-path inset that keeps
// a zoomed photo inside its own box even when the parent doesn't clip (src/index.css). A photo
// with rounded corners sets --fr-radius (its border-radius) in its own CSS.
import { framingProps, effectiveFraming } from "./framing";

const pct = (v) => `${Math.round(v * 1000) / 1000}%`;

// The part of the (unscaled) box that stays inside the box once scaled around the focus point.
const insetOf = ({ x, y, zoom }) => {
  const k = 1 - 1 / zoom;
  return `${pct(y * k)} ${pct((100 - x) * k)} ${pct((100 - y) * k)} ${pct(x * k)}`;
};

export function framed(framing, className, style) {
  const fr = framingProps(framing);
  if (!fr.className) return { className, style };
  const e = effectiveFraming(framing);
  return {
    className: className ? `${className} ${fr.className}` : fr.className,
    style: {
      ...style,
      ...fr.style,
      "--fi-d": insetOf(e.desktop),
      "--fi-t": insetOf(e.tablet),
      "--fi-p": insetOf(e.phone),
    },
  };
}

/** True when the photo has framing set (some sites switch object-fit to cover then). */
export const isFramed = (framing) => !!framingProps(framing).className;
